import { render, staticRenderFns } from "./Meet_the_team.vue?vue&type=template&id=16a000dd&"
import script from "./Meet_the_team.vue?vue&type=script&lang=js&"
export * from "./Meet_the_team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports